import { render } from "./AllExamState.vue?vue&type=template&id=1d8b66b6"
import script from "./AllExamState.vue?vue&type=script&lang=js"
export * from "./AllExamState.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__